<template>
  <div>
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" step="1">
          Información Básica
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="stepper > 2" step="2">
          Actividades
        </v-stepper-step>

        <v-divider
          v-if="
            this.charge.can_add_achievements ||
            this.charge.can_add_statistics ||
            this.charge.can_add_accompaniments
          "
        ></v-divider>

        <v-stepper-step
          :complete="stepper > step.stepAchievements"
          :step="step.stepAchievements"
          v-if="this.charge.can_add_achievements"
        >
          Evidencia de Logros
        </v-stepper-step>

        <v-divider v-if="this.charge.can_add_statistics"></v-divider>

        <v-stepper-step
          :complete="stepper > step.stepStatistics"
          :step="step.stepStatistics"
          v-if="this.charge.can_add_statistics"
        >
          Estadísticas
        </v-stepper-step>

        <v-divider v-if="this.charge.can_add_accompaniments"></v-divider>

        <v-stepper-step
          :complete="stepper > step.stepAccompaniments"
          :step="step.stepAccompaniments"
          v-if="this.charge.can_add_accompaniments"
        >
          Acompañamiento
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-progress-linear
            value="15"
            indeterminate
            absolute
            top
            v-if="this.$store.state.charge.isLoading"
          ></v-progress-linear>

          <v-expansion-panels primary v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                color="primary"
                class="white--text font-weight-bold"
              >
                Aprende a subir tus documentos
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-left py-4">
                <v-sheet
                  color="primary"
                  elevation="2"
                  class="white--text font-weight-medium pa-2 mb-7"
                >
                  El peso máximo de cada archivo debe ser de 1 MB, si tus
                  archivos pesan mas que esto debes comprimir el peso de cada
                  archivo hasta que pesen menos de los 1 MB mencionados
                  anteriormente. Abajo podrá encontrar distintas páginas para
                  comprimir sus archivos.
                </v-sheet>

                <v-row align="center" justify="space-around">
                  <v-btn
                    color="primary"
                    href="https://tools.pdf24.org/es/comprimir-pdf#s=1647293335228"
                    target="_blanck"
                  >
                    Comprimir PDF
                  </v-btn>

                  <v-btn
                    color="primary"
                    href="https://www.ilovepdf.com/es/jpg_a_pdf"
                    target="_blanck"
                  >
                    Imagen a PDF
                  </v-btn>

                  <v-btn
                    color="primary"
                    href="https://www.ilovepdf.com/es/word_a_pdf"
                    target="_blanck"
                  >
                    Word a PDF
                  </v-btn>

                  <v-btn
                    color="primary"
                    href="https://www.ilovepdf.com/es/excel_a_pdf"
                    target="_blanck"
                  >
                    Excel a PDF
                  </v-btn>

                  <v-btn
                    color="primary"
                    href="https://www.ilovepdf.com/es/powerpoint_a_pdf"
                    target="_blanck"
                  >
                    POWERPOINT a PDF
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-form ref="formReport" v-model="formReport">
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="model.modality"
                    label="Programas"
                    required
                  ></v-text-field>
                </v-col>
       
                <v-col cols="12" md="12" v-if="charge.can_add_achievements">
                  <v-textarea
                    v-model="model.achievements"
                    label="Logros Alcanzados"
                    required
                    :rules="[
                      this.$store.state.rules.required,
                      this.$store.state.rules.max_achievements,
                    ]"
                    counter
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="model.conclusions"
                    label="Conclusiones"
                    required
                    :rules="[
                      this.$store.state.rules.required,
                      this.$store.state.rules.max_conclusions,
                    ]"
                    counter
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <v-btn color="primary" @click="stepper = 2">
            {{ titleButtonStepper }}
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <activities-form
            :model="model"
            :charge="charge"
            :typeActivity="typeActivity"
            :rules="rules"
            :edit="true"
          ></activities-form>

          <v-btn color="primary" @click="nextStep('activities')">
            {{ stepper == step ? "Guardar" : "Siguiente" }}
          </v-btn>
          <v-btn text @click="stepper = 1"> Volver </v-btn>
        </v-stepper-content>

        <v-stepper-content
          :step="step.stepAchievements"
          v-if="this.charge.can_add_achievements"
        >
          <evidences-form
            :model="model"
            :charge="charge"
            :rules="rules"
            :edit="true"
          ></evidences-form>

          <v-btn color="primary" @click="nextStep('evidences')">
            {{ stepper == step ? "Guardar" : "Siguiente" }}
          </v-btn>
          <v-btn text @click="stepper = step.stepAchievements - 1">
            Volver
          </v-btn>
        </v-stepper-content>

        <v-stepper-content
          :step="step.stepStatistics"
          v-if="this.charge.can_add_statistics"
        >
          <statistics-form
            :model="model"
            :charge="charge"
            :typeStatistics="typeStatistics"
            :edit="true"
          ></statistics-form>

          <v-btn color="primary" @click="nextStep('statistics')">
            {{ stepper == step ? "Guardar" : "Siguiente" }}
          </v-btn>
          <v-btn text @click="stepper = step.stepStatistics - 1">
            Volver
          </v-btn>
        </v-stepper-content>

        <v-stepper-content
          :step="step.stepAccompaniments"
          v-if="this.charge.can_add_accompaniments"
        >
          <accompaniments-form
            :model="model"
            :charge="charge"
            :rules="rules"
            :edit="true"
          ></accompaniments-form>

          <v-btn color="primary" @click="nextStep('accompaniments')">
            {{ stepper == step ? "Guardar" : "Siguiente" }}
          </v-btn>
          <v-btn text @click="stepper = step.stepAccompaniments - 1">
            Volver
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <!-- Dialog loader -->
    <v-dialog
      v-model="this.$store.state.contract.isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_REPORT } from "@/store/report";
import { SET_ALERT } from "@/store/alert";
import EvidencesForm from "@/components/report/create/Evidences";
import ActivitiesForm from "@/components/report/create/Activities";
import StatisticsForm from "@/components/report/create/Statistics";
import AccompanimentsForm from "@/components/report/create/Accompaniments";
export default {
  name: "CreateReport",
  props: ["contract", "id"],
  components: {
    EvidencesForm,
    ActivitiesForm,
    StatisticsForm,
    AccompanimentsForm,
  },
  data: () => ({
    panel: [0],
    countStep: 3,
    stepper: 1,
    formReport: true,
    model: {
      modality: "",
      workshop: "",
      conclusions: "",
      achievements: "",
      contract_id: "",
      evidences: [],
      activities: [],
      statistics: [],
      accompaniments: [],
    },
    step: {
      stepAchievements: 3,
      stepStatistics: 4,
      stepAccompaniments: 5,
    },
    rules: {
      file: (value) => !!value || "Documento obligatorio",
      max_file: (value) =>
        !value ||
        value.size < 20971520 ||
        "El documento debe pesar menos de 20MB",
    },
  }),
  created() {
    if (this.id) this.$store.dispatch("getReport", this.id);

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_REPORT) {
        this.model.activities = state.report.report.activities;
        this.model.achievements = state.report.report.achievements;
        this.model.conclusions = state.report.report.conclusions;
      }
    });

    if (this.charge) {
      this.stepNumber();
    }
  },
  computed: {
    charge() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.employee.charge
        : "";
    },
    titleButtonStepper() {
      return this.id ? "Editar" : "Continuar";
    },
    typeActivity() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.employee.charge.type_activities
        : "";
    },
    typeStatistics() {
      return this.$store.state.status.typeStatistics;
    },
  },
  watch: {
    charge() {
      this.stepNumber();
    },
  },
  methods: {
    stepNumber() {
      if (this.charge.can_add_achievements) {
        this.step.stepAchievements = this.countStep;
        this.countStep++;
      }

      if (this.charge.can_add_statistics) {
        this.step.stepStatistics = this.countStep;
        this.countStep++;
      }

      if (this.charge.can_add_accompaniments) {
        this.step.stepAccompaniments = this.countStep;
        this.countStep++;
      }

      this.countStep--;
    },
    nextStep(type) {
      let valid = true;

      switch (type) {
        case "evidences":
          if (!this.model.evidences.length) {
            this.$store.commit(SET_ALERT, {
              message: "Debe agregar minimo una evidencia",
              type: "error",
            });
            valid = false;
          }
          break;

        case "activities":
          if (!this.model.activities.length) {
            this.$store.commit(SET_ALERT, {
              message: "Debe agregar minimo una atividad",
              type: "error",
            });
            valid = false;
          }
          break;

        case "statistics":
          if (!this.model.statistics.length) {
            this.$store.commit(SET_ALERT, {
              message: "Debe agregar las estadísticas interna y externa",
              type: "error",
            });
            valid = false;
          }
          break;

        case "accompaniments":
          if (!this.model.accompaniments.length) {
            this.$store.commit(SET_ALERT, {
              message: "Debe agregar minimo un acompañamiento",
              type: "error",
            });
            valid = false;
          }
          break;
      }

      if (valid) {
        console.log(this.stepper, this.countStep);
        if (this.stepper == this.countStep) {
          this.saveReport();
        } else {
          this.stepper += 1;
        }
      } else {
        return false;
      }
    },
    async saveReport() {
      if (this.id) {
        delete this.model.evidences;
        delete this.model.contract_id;
        this.$store.dispatch("updateReport", {
          id: this.id,
          form: this.model,
        });
      } else {
        this.model.contract_id = this.contract;
        this.$store.dispatch("createReport", this.createFormData());
      }
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          if (value.length) {
            formData = this.getItem(value, key, formData);
          } else {
            formData.append(key, value);
          }
        } else {
          formData.append(key, value);
        }
      });
      return formData;
    },
    getItem(array, key, formData) {
      array.forEach((element, index) => {
        Object.entries(element).forEach(([keyItem, valueItem]) => {
          if (Array.isArray(valueItem)) {
            if (valueItem.length) {
              formData = this.getSubItem(
                valueItem,
                key,
                formData,
                index,
                keyItem
              );
            }
          } else {
            formData.append(
              key + "[" + index + "]" + "[" + keyItem + "]",
              valueItem
            );
          }
        });
      });
      return formData;
    },
    getSubItem(array, key, formData, index, keyItem) {
      array.forEach((element, subIndex) => {
        Object.entries(element).forEach(([keySubItem, valueSubItem]) => {
          formData.append(
            key +
              "[" +
              index +
              "]" +
              "[" +
              keyItem +
              "]" +
              "[" +
              subIndex +
              "]" +
              "[" +
              keySubItem +
              "]",
            valueSubItem
          );
        });
      });
      return formData;
    },
  },
};
</script>
